<!-- ========================= 
 Header
========================= -->
<!-- <div class="title_div">
  <div class="w-100 d-flex justify-content-between align-items-center" >
    <div class="title_sub_div_1 title_right_icon_div">Source Board</div>
    <div class="title_sub_div_1 mt-1 mr-1">
      <i class="fa fa-home" (click)="home()" title="Dashboard"></i>
    </div>
  </div>
</div> -->


<div style="margin-top:13px; padding: 0 15px;">
  <div class="metrics-row">
    <!-- Completion % -->
    <div class="metric-card metric-card-blue">
      <div class="metric-content">
        <div class="metric-text-block">
          <div class="metric-value">{{ metrics.completionPercentage }}%</div>
          <div class="metric-label">Completion %</div>
        </div>
      </div>
      <div class="metric-icon-right">
        <i class="fa fa-pie-chart"></i>
      </div>
    </div>

    <!-- Total parts -->
    <div class="metric-card metric-card-green">
      <div class="metric-content">
        <div class="metric-text-block">
          <div class="metric-value">{{ metrics.parts }}</div>
          <div class="metric-label">Total parts</div>
        </div>
      </div>
      <div class="metric-icon-right">
        <i class="fa fa-cubes"></i>
      </div>
    </div>

    <!-- Closed parts -->
    <div class="metric-card metric-card-purple">
      <div class="metric-content">
        <div class="metric-text-block">
          <div class="metric-value">{{ metrics.closedParts }}</div>
          <div class="metric-label">Closed parts</div>
        </div>
      </div>
      <div class="metric-icon-right">
        <i class="fa fa-check-circle"></i>
      </div>
    </div>

    <!-- Total cost -->
    <div class="metric-card metric-card-orange">
      <div class="metric-content">
        <div class="metric-text-block">
          <div class="metric-value">{{ metrics.totalValue }}</div>
          <div class="metric-label">Total Cost</div>
        </div>
      </div>
      <div class="metric-icon-right">
        <i class="fa fa-inr"></i>
      </div>
    </div>
  </div>
</div>
<!-- =========================
 Main Container
========================= -->
<div class="container-fluid analysis-container">

  <div *ngIf="showCostDateFilter" class="date-filter-row mb-3">
    <input type="date" [(ngModel)]="costStartDate" class="form-control form-control-sm">
    <input type="date" [(ngModel)]="costEndDate" class="form-control form-control-sm">
    <button class="btn btn-sm btn-primary" (click)="loadCostByCurrency()">Apply</button>
    <button class="btn btn-sm btn-outline-secondary" (click)="cancelCostDateFilter()">Cancel</button>
  </div>


  <!-- =========================================================
   ROW – 1  (3 columns)
   Currency | Payment Term | Project History
  ========================================================= -->
  <div class="row mt-3 align-items-stretch">

    <!-- Currency Distribution -->
    <div class="col-lg-4 col-md-6 col-12 d-flex">
      <div class="chart-card h-100 w-100">
        <div class="d-flex justify-content-between align-items-center mb-2">
          <h5 class="chart-title mb-0"><i class="fa fa-pie-chart chart-title-icon"></i> Currency Distribution</h5>
          <button class="btn btn-sm btn-light" title="Filter by date" (click)="toggleCostDateFilter()">📅</button>
        </div>

        <div class="chart-container cost-chart" style="cursor: pointer;">
          <canvas baseChart [data]="costChartData" [type]="costChartType" [options]="chartOptions"
            [legend]="chartLegend">
          </canvas>
        </div>
      </div>
    </div>

    <!-- Payment Term -->

    <div class="col-lg-4 col-md-6 col-12 d-flex">
      <div class="chart-cardkey h-100 w-100">

        <div class="d-flex justify-content-between align-items-center mb-2">
          <h5 class="chart-title mb-0">Key Vendors</h5>
          <button class="btn btn-sm btn-light" (click)="toggleTopVendorFilter()">🔽</button>
        </div>

        <div *ngIf="showTopVendorFilter" class="mb-2" style="max-width:120px">
          <select class="form-select form-select-sm" [(ngModel)]="selectedTopN" (change)="loadMasterData()">
            <option [ngValue]="5">Top 5</option>
            <option [ngValue]="10">Top 10</option>
            <option [ngValue]="20">Top 20</option>
          </select>
        </div>

        <div class="table-scroll">
          <table class="details-table">
            <thead>
              <tr>
                <th>Vendor</th>
                <th>Value</th>
                <th>Count</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let vendor of masterDataList" style="cursor: pointer;" (click)="onVendorClick(vendor)"
                title="Click to view this vendor in Supply Sense">
                <td style="cursor: pointer; color: #0066cc; text-decoration: underline;">{{ vendor.supplier }}</td>
                <td>{{ vendor.total_value | number:'1.0-0' }}</td>
                <td>{{ vendor.count }}</td>
              </tr>
            </tbody>
          </table>
        </div>

      </div>
    </div>

    <!-- Project History and Considerations -->
    <div class="col-lg-4 col-md-12 col-12 d-flex">
      <div class="info-cards h-100 w-100">

        <h5 class="info-title">Project History and Considerations</h5>
        <ul class="history-list">
          <li *ngFor="let history of projectHistory">
            {{ history.title }}
          </li>
          <li *ngIf="projectHistory.length === 0" class="text-muted">
            No notifications available for this project
          </li>
        </ul>

      </div>
    </div>

  </div>


  <!-- =========================================================
   ROW – 2  (3 columns)
   Offline/Online | Key Vendors | Part / LT
   ========================================================= -->
  <div *ngIf="showOfflineOnlineDateFilter" class="date-filter-row mb-3">
    <input type="date" [(ngModel)]="offlineOnlineStartDate" class="form-control form-control-sm">
    <input type="date" [(ngModel)]="offlineOnlineEndDate" class="form-control form-control-sm">
    <button class="btn btn-sm btn-primary" (click)="getOfflineOnlineSummary()">Apply</button>
    <button class="btn btn-sm btn-outline-secondary" (click)="cancelOfflineOnlineDateFilter()">Cancel</button>
  </div>
  <div class="row mt-3 align-items-stretch">

    <!-- Offline vs Online -->
    <div class="col-lg-4 col-md-6 col-12 d-flex">
      <div class="chart-cardkeys h-100 w-100">
        <div class="d-flex justify-content-between align-items-center mb-2">
          <h5 class="chart-title mb-0"><i class="fa fa-bar-chart chart-title-icon"></i> Offline vs Online</h5>
          <button class="btn btn-sm btn-light" (click)="toggleOfflineOnlineDateFilter()">📅</button>
        </div>

        <div class="chart-container offline-online-chart">
          <canvas baseChart [datasets]="offlineOnlineChartData.datasets" [labels]="offlineOnlineChartData.labels"
            [options]="chartOptions" [legend]="chartLegend" [type]="offlineOnlineChartType">
          </canvas>
        </div>
      </div>
    </div>

    <!-- Key Vendors -->
    <!-- <div class="col-lg-4 col-md-6 col-12 d-flex">
      <div class="chart-cardkey h-100 w-100">

        <div class="d-flex justify-content-between align-items-center mb-2">
          <h5 class="chart-title mb-0">Key Vendors</h5>
          <button class="btn btn-sm btn-light"
                  (click)="toggleTopVendorFilter()">🔽</button>
        </div>

        <div *ngIf="showTopVendorFilter" class="mb-2" style="max-width:120px">
          <select class="form-select form-select-sm"
                  [(ngModel)]="selectedTopN"
                  (change)="loadMasterData()">
            <option [ngValue]="5">Top 5</option>
            <option [ngValue]="10">Top 10</option>
            <option [ngValue]="20">Top 20</option>
          </select>
        </div>

        <div class="table-scroll">
          <table class="details-table">
            <thead>
              <tr>
                <th>Vendor</th>
                <th>Value</th>
                <th>Count</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let vendor of masterDataList" 
                  style="cursor: pointer;" 
                  (click)="onVendorClick(vendor)"
                  title="Click to view this vendor in Supply Sense">
                <td style="cursor: pointer; color: #0066cc; text-decoration: underline;">{{ vendor.supplier }}</td>
                <td>{{ vendor.total_value | number:'1.0-0' }}</td>
                <td>{{ vendor.count }}</td>
              </tr>
            </tbody>
          </table>
        </div>

      </div>
    </div> -->
    <div class="col-lg-4 col-md-6 col-12 d-flex">
      <div class="chart-card h-100 w-100">

        <h5 class="chart-title">Payment Term</h5>

        <table class="vendors-table">
          <thead>
            <tr>
              <th>Payment term</th>
              <th>Value</th>
              <th>%</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let payment of paymentTerms">
              <td>{{ payment.term }}</td>
              <td>{{ payment.value }}</td>
              <td>{{ payment.percentage }}%</td>
            </tr>
          </tbody>
        </table>

      </div>
    </div>
    <!-- Part / LT -->
    <div class="col-lg-4 col-md-12 col-12 d-flex">
      <div class="chart-cards h-100 w-100">

        <div class="d-flex justify-content-between align-items-center mb-2">
          <h5 class="chart-title mb-0">Part / LT</h5>
          <button class="btn btn-sm btn-light" (click)="togglePartLtTopFilter()">🔽</button>
        </div>

        <div *ngIf="showPartLtTopFilter" class="mb-2" style="max-width:120px">
          <select class="form-select form-select-sm" [(ngModel)]="selectedPartLtTopN" (change)="loadPartLeadtime()">
            <option [ngValue]="5">Top 5</option>
            <option [ngValue]="10">Top 10</option>
            <option [ngValue]="20">Top 20</option>
          </select>
        </div>

        <div class="table-scroll">
          <table class="details-table">
            <thead>
              <tr>
                <th>Part</th>
                <th>LT</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of partLeadtimeList">
                <td style="cursor: pointer; color: #0066cc; text-decoration: underline;"
                  (click)="navigateToPartInProjectView($event, row.internalPartNo)"
                  title="Click to view this part in project-view">{{ row.internalPartNo }}</td>
                <td>{{ row.leadTime }}</td>
              </tr>
            </tbody>
          </table>
        </div>

      </div>
    </div>

  </div>


  <!-- =========================================================
   ROW – 3  (2 columns)
   Part Deviation | Quantity Diff
  ========================================================= -->
  <div class="row mt-3 align-items-stretch">

    <!-- Part Deviation -->
    <div class="col-lg-6 col-12 d-flex">
      <div class="info-cardpart h-100 w-100">

        <div class="d-flex justify-content-between align-items-center mb-2">
          <h5 class="mb-0">Part Deviation (INR)</h5>
          <button class="btn btn-sm btn-light" (click)="togglePartDeviationTopFilter()">🔽</button>
        </div>

        <div *ngIf="showPartDeviationTopFilter" class="mb-2" style="max-width:120px">
          <select class="form-select form-select-sm" [(ngModel)]="selectedPartDeviationTopN"
            (change)="loadPartPricingSummary()">
            <option [ngValue]="5">Top 5</option>
            <option [ngValue]="10">Top 10</option>
            <option [ngValue]="20">Top 20</option>
          </select>
        </div>

        <div class="table-scroll">
          <table class="details-table">
            <thead>
              <tr>
                <th>Part</th>
                <th>Deviation (INR)</th>
                <th>Considered</th>
                <th>Minimum Price</th>
                <th>Minimum Price PO</th>
                <!-- <th>Project Id</th> -->
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of partDeviationList">

                <td style="cursor: pointer; color: #0066cc; text-decoration: underline;"
                  (click)="navigateToPartInProjectView($event, row.internalPartNo)"
                  title="Click to view this part in project-view">{{ row.internalPartNo }}</td>

                <!-- Deviation -->
                <td [style.color]="row.considered > getBestMinimum(row) ? '#dc2626' : null"
                  [style.fontWeight]="row.considered > getBestMinimum(row) ? '600' : null">
                  {{ row.deviation | number:'1.0-2' }}
                </td>

                <!-- Considered -->
                <td>
                  {{ row.considered | number:'1.0-2' }}
                </td>

                <!-- Minimum Price -->
                <td [style.color]="
      row.considered > getBestMinimum(row) &&
      +row.minimumPrice === getBestMinimum(row)
        ? '#16a34a'
        : null
    " [style.fontWeight]="
      row.considered > getBestMinimum(row) &&
      +row.minimumPrice === getBestMinimum(row)
        ? '600'
        : null
    ">
                  {{ row.minimumPrice | number:'1.0-2' }}
                </td>

                <!-- Minimum Price PO -->
                <td [style.color]="
      row.minimumPriceFromPO !== 'NA' &&
      +row.minimumPriceFromPO === getBestMinimum(row)
        ? '#16a34a'
        : null
    " [style.fontWeight]="
      row.minimumPriceFromPO !== 'NA' &&
      +row.minimumPriceFromPO === getBestMinimum(row)
        ? '600'
        : null
    ">
                  {{
                  row.minimumPriceFromPO === 'NA'
                  ? 'NA'
                  : (row.minimumPriceFromPO | number:'1.0-2')
                  }}
                </td>

                <!-- <td>{{ row.project_id }}</td> -->

              </tr>
            </tbody>
          </table>
        </div>

      </div>
    </div>

    <!-- Quantity Diff -->
    <div class="col-lg-6 col-12 d-flex">
      <div class="info-card h-100 w-100">

        <div class="d-flex justify-content-between align-items-center mb-2">
          <h5 class="mb-0">Quantity Diff</h5>
          <button class="btn btn-sm btn-light" (click)="toggleQtyDiffTopFilter()">🔽</button>
        </div>

        <div *ngIf="showQtyDiffTopFilter" class="mb-2" style="max-width:120px">
          <select class="form-select form-select-sm" [(ngModel)]="selectedQtyDiffTopN" (change)="loadQuantityDiff()">
            <option [ngValue]="5">Top 5</option>
            <option [ngValue]="10">Top 10</option>
            <option [ngValue]="20">Top 20</option>
          </select>
        </div>

        <div class="table-scroll">
          <table class="details-table">
            <thead>
              <tr>
                <th>Part</th>
                <th>Supplier Name</th>
                <th>Required Qty</th>
                <th>Available Qty</th>
                <th>Quantity Diff</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let detail of partDetails">
                <td style="cursor: pointer; color: #0066cc; text-decoration: underline;"
                  (click)="navigateToPartInProjectView($event, detail.internalPartNo)"
                  title="Click to view this part in Supply Sense">{{ detail.internalPartNo }}</td>
                <td>{{ detail.supplier_name }}</td>
                <td>{{ detail.req_qty }}</td>
                <td>{{ detail.available_qty }}</td>
                <!-- <td>{{ detail.QuantityDiff }}</td> -->
                <td [style.color]="+detail.QuantityDiff > 0 ? '#dc2626' : null"
                  [style.fontWeight]="+detail.QuantityDiff > 0 ? '600' : null">
                  {{ detail.QuantityDiff }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

      </div>
    </div>

  </div>

</div>